<!-- <div
  [ngClass]="{
    'blank-page':
      router.url === '/authentication' ||
      router.url === '/authentication/sign-up' ||
      router.url === '/authentication/forgot-password' ||
      router.url === '/authentication/reset-password' ||
      router.url === '/authentication/lock-screen' ||
      router.url === '/authentication/logout' ||
      router.url === '/authentication/confirm-email' ||
      router.url === '/coming-soon'
  }"
  [class.card-borderd-theme]="themeService.isCardBorder()"
  [class.card-border-radius]="themeService.isCardBorderRadius()"
  [class.rtl-enabled]="themeService.isRTLEnabled()"
>
 
  <app-sidebar />


  <div
    class="main-content transition d-flex flex-column"
    [ngClass]="{ active: isSidebarToggled }"
    [class.right-sidebar]="themeService.isRightSidebar()"
    [class.hide-sidebar]="themeService.isHideSidebar()"
  >
    <app-header />
    <router-outlet />
    <div class="flex-grow-1"></div>
    <app-footer />
  </div>
</div> -->
<mat-card class="daxa-card payments-card full-page-card border-none d-block"
  [class.component-dark-theme]="themeService.isDark()" [class.rtl-enabled]="themeService.isRTLEnabled()"
  *ngIf="loading">
  <div class="loading-spinner">
    <mat-spinner diameter="120" strokeWidth="2"></mat-spinner>
    <p>Loading, Please wait a moment</p>
  </div>
</mat-card>

<app-lock-screen *ngIf="locked$ | async"></app-lock-screen>

<div [class.app-disabled]="locked$ | async">
  <router-outlet></router-outlet>
</div>